export const orderData = {
  itemsSubtotal: 8957,
  itemsTotal: 10300,
  itemsTax: 1343,
  taxPercent: 15,
  total: 10506,
  totalMainUnit: 105,
  totalFractionalUnit: 6,
  serviceFeePercent: 0,
  serviceFeeSubtotal: 0,
  serviceFeeTotal: 0,
  serviceFeeTax: 0,
  url: "albaik://drive-thru?order=5rvNteLDPkKLezrd5iACmg",
  albaikIdentifier: "D1568",
  backupPin: "866",
  id: 27468,
  createdAt: 1750156121,
  feesTotal: 0,
  status: "Accepted",
  deliveryMethod: "offline_drive_thru",
  countryCode: "SA",
  favorite: false,
  favoriteName: null,
  posOrderIdentifier: "D1568",
  branch: {
    addressDescription: "Al-Baik BFX POSist lab",
    city: "Jeddah",
    id: 107,
    isOpen: false,
    latitude: 21.5615979,
    longitude: 39.2234012,
    name: "POSist test lab",
    deliveryMethods: ["home_delivery", "offline_drive_thru", "pickup"],
    supportsPickupCustomerArrivalFlow: true,
    hasCustomMenu: true,
    acceptingInStoreOrders: true,
    acceptingCurbsideOrders: true,
    hasCustomPricingForDelivery: false,
    showSosNumberInAlbaikApp: true,
    curbsideExpectedBranchDelayMinutes: 5,
    estimatedWaitingTime: 12,
    licensee: {
      id: 1,
      code: "EFC",
      name: "Express Food Company",
      vat: "300197158200003",
      commercialRegistration: "4030043976",
    },
    openingHours: [
      {
        closesAt: 240,
        opensAt: 360,
      },
      {
        closesAt: 240,
        opensAt: 360,
      },
      {
        closesAt: 240,
        opensAt: 360,
      },
      {
        closesAt: 240,
        opensAt: 360,
      },
      {
        closesAt: 240,
        opensAt: 360,
      },
      {
        closesAt: 240,
        opensAt: 360,
      },
      {
        closesAt: 240,
        opensAt: 360,
      },
    ],
  },
  lane: {
    id: 26,
    name: "Offline",
  },
  driveThru: {
    status: "placed",
  },
  fees: [],
  items: [
    {
      productId: 1,
      quantity: 1,
      total: 7000,
      productName: "ALBAIK 4 Piece Chicken Meal",
      choices: [],
      comboChoices: [],
    },
    {
      productId: 3,
      quantity: 1,
      total: 3300,
      productName: "ALBAIK 8 Piece Chicken Meal",
      choices: [],
      comboChoices: [],
    },
  ],
};
